import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface IMacCardInfo {
  id: number;
  img: string;
  selected: boolean;
}
export interface IMacDecType extends IMacCardInfo {
  show: boolean;
  deck: string;
  deckCover: string;
  deckColor?: string;
}
/** Выбор карт одного клиента (по identity участника в групповой терапии) */
export interface IMacClientSelection {
  participantIdentity: string;
  cards: IMacCardInfo[];
}

/** Данные об «общем экране» — карты участника, которого психолог сейчас просматривает */
export interface IMacSharedView {
  participantLabel: string;
  cards: IMacCardInfo[];
}

export interface IMacCardsState {
  currentDec: IMacDecType[];
  selected: IMacCardInfo[];
  /** Выборы по участникам для психолога (групповая терапия) */
  clientSelectionsByParticipant: Record<string, IMacCardInfo[]>;
  /** Карты, транслируемые психологом на «общий экран» (для клиентов в групповой терапии) */
  sharedView: IMacSharedView | null;
}

const areCardsEqual = (left: IMacCardInfo[], right: IMacCardInfo[]) => {
  if (left === right) return true;
  if (left.length !== right.length) return false;

  for (let i = 0; i < left.length; i += 1) {
    const l = left[i];
    const r = right[i];
    if (l.id !== r.id || l.img !== r.img || l.selected !== r.selected) {
      return false;
    }
  }

  return true;
};

const initialState: IMacCardsState = {
  currentDec: [],
  selected: [],
  clientSelectionsByParticipant: {},
  sharedView: null,
};

export const macStateSlice = createSlice({
  name: 'macCardsState',
  initialState,
  reducers: {
    setMacDec: (state, action: PayloadAction<IMacDecType[]>) => {
      state.currentDec = action.payload;
    },
    setMacSelected: (state, action: PayloadAction<IMacCardInfo[]>) => {
      if (areCardsEqual(state.selected, action.payload)) {
        return;
      }
      state.selected = action.payload;
    },
    setMacClientSelection: (state, action: PayloadAction<IMacClientSelection>) => {
      const { participantIdentity, cards } = action.payload;
      const prevCards = state.clientSelectionsByParticipant[participantIdentity] ?? [];
      if (areCardsEqual(prevCards, cards)) {
        return;
      }
      state.clientSelectionsByParticipant[participantIdentity] = cards;
    },
    clearMacClientSelections: (state) => {
      state.clientSelectionsByParticipant = {};
    },
    setMacSharedView: (state, action: PayloadAction<IMacSharedView>) => {
      state.sharedView = action.payload;
    },
    clearMacSharedView: (state) => {
      state.sharedView = null;
    },
  },
});

export const {
  setMacDec,
  setMacSelected,
  setMacClientSelection,
  clearMacClientSelections,
  setMacSharedView,
  clearMacSharedView,
} = macStateSlice.actions;
export default macStateSlice.reducer;
